import { axiosInstance } from '../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../Shared/Utils/UrlConstants';

const Service = {
  userProfile: (data) => {
    return axiosInstance.get(ApiUrlConstant.userProfile(), data, { loaderKey: 'userData' });
  },
  updateUserProfile: (data) => {
    return axiosInstance.put(ApiUrlConstant.userProfile(), data, {
      headers: data instanceof FormData ? undefined : { 'Content-Type': 'application/json' },
      loaderKey: 'updateUser',
    });
  },

  changePasswordUser: (data) => {
    return axiosInstance.post(ApiUrlConstant.changePasswordUser(), data, { loaderKey: 'changePassUser' });
  },
};

export default Service;
